import { render, staticRenderFns } from "./prof-info.vue?vue&type=template&id=7b98b4d2&scoped=true&"
import script from "./prof-info.vue?vue&type=script&lang=js&"
export * from "./prof-info.vue?vue&type=script&lang=js&"
import style0 from "./prof-info.vue?vue&type=style&index=0&id=7b98b4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b98b4d2",
  null
  
)

export default component.exports